import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageSEO from '../components/SEO/PageSEO';
import FAQAccordion from '../components/FAQ/FAQAccordion';
import { faqData } from '../data/faqData';
import { Book, Users, GitMerge, GraduationCap, School, ExternalLink, X, ChevronLeft, ChevronRight, FileText, Video, Award, Check } from 'lucide-react';

const FichesSESPage = () => {
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null);
  const [currentMainImage, setCurrentMainImage] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Images des fiches pour le carrousel principal
  const ficheImages = [
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FFiches%20r%C3%A9vision%2FVisuel-boite-SES.png?alt=media&token=15dd1289-c681-490d-b23d-1b0bdeb4747e',
      alt: 'Le Bac de SES en 35 fiches + 35 vidéos - Boîte'
    },
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FFiches%20r%C3%A9vision%2FMS-1-Recto.png?alt=media&token=71debdb9-43dc-4050-a67c-b6811c35fe13',
      alt: 'Fiche Mobilité Sociale - Recto'
    },
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FFiches%20r%C3%A9vision%2FMS-1-Verso.png?alt=media&token=422e85a9-59c6-4e86-a783-d2eb59191e9d',
      alt: 'Fiche Mobilité Sociale - Verso'
    },
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FFiches%20r%C3%A9vision%2FChomage-2-Recto.png?alt=media&token=dcec5da6-e8b0-4c56-bc87-da11b5b8d062',
      alt: 'Fiche Chômage - Recto'
    },
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FFiches%20r%C3%A9vision%2FChomage-2-Verso.png?alt=media&token=6c322643-9a91-4366-b649-c0aeeaecde11',
      alt: 'Fiche Chômage - Verso'
    }
  ];

  // Images d'exemples pour la section aperçu (garder les anciennes)
  const exampleImages = [
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FFiches%20r%C3%A9vision%2FMS-1-Recto.png?alt=media&token=71debdb9-43dc-4050-a67c-b6811c35fe13',
      alt: 'Fiche Mobilité Sociale - Recto'
    },
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FFiches%20r%C3%A9vision%2FMS-1-Verso.png?alt=media&token=422e85a9-59c6-4e86-a783-d2eb59191e9d',
      alt: 'Fiche Mobilité Sociale - Verso'
    },
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FFiches%20r%C3%A9vision%2FChomage-2-Recto.png?alt=media&token=dcec5da6-e8b0-4c56-bc87-da11b5b8d062',
      alt: 'Fiche Chômage - Recto'
    },
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FFiches%20r%C3%A9vision%2FChomage-2-Verso.png?alt=media&token=6c322643-9a91-4366-b649-c0aeeaecde11',
      alt: 'Fiche Chômage - Verso'
    }
  ];

  const [currentCarouselIndex, setCurrentCarouselIndex] = useState(0);

  // Contenu des fiches par thème
  const fichesByTheme = [
    {
      theme: 'Sociologie',
      icon: Users,
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
      borderColor: 'border-purple-200',
      fiches: [
        { count: 3, title: 'Structure sociale' },
        { count: 4, title: 'Mobilité sociale' },
        { count: 5, title: 'Travail et emploi' },
        { count: 3, title: 'Engagement politique' }
      ]
    },
    {
      theme: 'Économie',
      icon: Book,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200',
      fiches: [
        { count: 3, title: 'Croissance économique' },
        { count: 3, title: 'Commerce international' },
        { count: 3, title: 'Chômage' },
        { count: 4, title: 'Europe' }
      ]
    },
    {
      theme: 'Regards Croisés',
      icon: GitMerge,
      color: 'text-emerald-600',
      bgColor: 'bg-emerald-50',
      borderColor: 'border-emerald-200',
      fiches: [
        { count: 3, title: 'Environnement' }
      ]
    },
    {
      theme: 'Méthodes et Outils',
      icon: GraduationCap,
      color: 'text-amber-600',
      bgColor: 'bg-amber-50',
      borderColor: 'border-amber-200',
      fiches: [
        { count: 4, title: 'Fiches méthode' },
        { count: 1, title: 'Fiche grand oral' },
        { count: 1, title: 'Fiche outil' }
      ]
    }
  ];

  const nextMainImage = () => {
    setCurrentMainImage((prev) => (prev + 1) % ficheImages.length);
  };

  const prevMainImage = () => {
    setCurrentMainImage((prev) => (prev - 1 + ficheImages.length) % ficheImages.length);
  };

  const nextImage = () => {
    setCurrentCarouselIndex((prev) => (prev + 1) % exampleImages.length);
  };

  const prevImage = () => {
    setCurrentCarouselIndex((prev) => (prev - 1 + exampleImages.length) % exampleImages.length);
  };

  // Schéma JSON-LD pour le produit
  const schema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Le Bac de SES en 35 fiches + 35 vidéos",
    "image": "https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FFiches%20r%C3%A9vision%2FVisuel-boite-SES.png?alt=media&token=15dd1289-c681-490d-b23d-1b0bdeb4747e",
    "description": "35 fiches de révision essentielles et leurs 35 vidéos explicatives pour maîtriser le programme de SES et réussir le bac. Conçu par Marion Moreau et Brandon Maestu.",
    "brand": {
      "@type": "Brand",
      "name": "Editions Docere"
    },
    "offers": {
      "@type": "Offer",
      "price": "19.90",
      "priceCurrency": "EUR",
      "availability": "https://schema.org/InStock",
      "url": "https://editions-docere.fr/le-bac-de-ses-en-35-fiches/",
      "priceValidUntil": "2025-12-31"
    },
    "author": [
      {
        "@type": "Person",
        "name": "Marion Moreau"
      },
      {
        "@type": "Person",
        "name": "Brandon Maestu"
      }
    ],
    "publisher": {
      "@type": "Organization",
      "name": "Editions Docere"
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <PageSEO
        title="Le Bac de SES en 35 fiches | Révisions Complètes et Vidéos"
        description="Maîtrisez le programme de SES avec nos 35 fiches de révision essentielles et leurs 35 vidéos explicatives. Conçu par Marion Moreau et Brandon Maestu pour votre réussite au bac."
        path="/fiches-ses"
        image="https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FFiches%20r%C3%A9vision%2FVisuel-boite-SES.png?alt=media&token=15dd1289-c681-490d-b23d-1b0bdeb4747e"
        type="product"
        schema={schema}
      />
      <Navbar />
      <main>
        {/* Section Héro */}
        <section className="relative bg-gradient-to-b from-[#9a6ebd]/10 to-white pt-20 sm:pt-32 pb-16 sm:pb-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col lg:grid lg:grid-cols-2 gap-8 lg:gap-12 lg:items-stretch">
              {/* Colonne gauche - Texte et CTA */}
              <div className="order-2 lg:order-1 w-full">
                <h1 className="text-3xl md:text-4xl font-bold text-[#323c5f] mb-6">
                  Le Bac de SES en 35 fiches + 35 vidéos
                </h1>
                <div className="bg-white rounded-xl p-4 sm:p-6 shadow-lg border-2 border-[#ceace8] mb-6 sm:mb-8">
                  <p className="text-base sm:text-lg text-gray-700 mb-3 sm:mb-4 leading-relaxed">
                    Salut à toi, futur bachelier en SES ! 👋 Nous sommes ravis de te présenter notre pack exclusif 
                    <span className="font-semibold text-[#9a6ebd]"> "Le Bac de SES en 35 fiches + 35 vidéos"</span>, 
                    des fiches pensées pour ta réussite.
                  </p>
                  
                  <p className="text-base sm:text-lg text-gray-700 mb-3 sm:mb-4 leading-relaxed">
 On sait que le programme de SES est dense et qu'il est parfois difficile 
                    de s'y retrouver et de tout retenir.
                  </p>
                  
                  <p className="text-base sm:text-lg text-gray-700 mb-3 sm:mb-4 leading-relaxed">
                    C'est pourquoi nous avons élaboré <span className="font-semibold text-[#323c5f]">35 fiches de révision 
                    claires, concises et structurées</span>, couvrant l'intégralité du programme de Terminale. 
                    Chaque fiche est associée à une <span className="font-semibold text-[#323c5f]">vidéo explicative détaillée</span>, 
                    pour que tu puisses tout comprendre et mémoriser à ton rythme.
                  </p>
                  
                  <div className="bg-[#9a6ebd]/10 border-l-4 border-[#9a6ebd] p-3 sm:p-4 rounded-r-lg">
                    <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
                      💡 <span className="font-semibold text-[#9a6ebd]">Le petit plus ?</span> Tu peux consulter les fiches partout, les annoter, et les vidéos te donnent 
                      des éléments supplémentaires pour maîtriser chaque chapitre. 
                    </p>
                  </div>
                </div>
                
                {/* Prix */}
                <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 mb-6 sm:mb-8">
                  <div className="text-3xl sm:text-4xl font-bold text-[#9a6ebd]">19,90€</div>
                  <div className="flex items-center gap-2 bg-green-50 text-green-700 px-3 py-1 rounded-full">
                    <Check size={16} />
                    <span className="text-sm font-medium">En stock</span>
                  </div>
                </div>

                {/* Bouton d'achat principal */}
                <a
                  href="https://editions-docere.fr/le-bac-de-ses-en-35-fiches/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center w-full sm:w-auto bg-[#9a6ebd] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl hover:bg-[#8a5dad] transition-colors text-base sm:text-lg font-semibold mb-6"
                >
                  Acheter maintenant
                  <ExternalLink className="ml-2" size={20} />
                </a>

                {/* Points forts */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                  <div className="flex items-center gap-2">
                    <FileText className="text-[#9a6ebd]" size={20} />
                    <span className="text-sm sm:text-base text-gray-600">35 fiches complètes</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Video className="text-[#9a6ebd]" size={20} />
                    <span className="text-sm sm:text-base text-gray-600">35 vidéos explicatives</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Award className="text-[#9a6ebd]" size={20} />
                    <span className="text-sm sm:text-base text-gray-600">Qualité premium</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <GraduationCap className="text-[#9a6ebd]" size={20} />
                    <span className="text-sm sm:text-base text-gray-600">Spécial Terminale</span>
                  </div>
                </div>
              </div>

              {/* Colonne droite - Image principale */}
              <div className="order-1 lg:order-2 w-full">
                <div className="space-y-6">
                  {/* Image principale */}
                  <div className="relative w-full h-64 sm:h-80 md:h-96 lg:h-[28rem] flex items-center justify-center overflow-hidden">
                    <img
                      src={ficheImages[currentMainImage].url}
                      alt={ficheImages[currentMainImage].alt}
                      className="max-w-full max-h-full object-contain bg-white rounded-xl sm:rounded-2xl shadow-lg border-2 border-[#ceace8] p-2 sm:p-4 cursor-pointer transition-transform hover:scale-105"
                      onClick={() => setSelectedImageIndex(currentMainImage)}
                    />
                    
                    {/* Boutons de navigation */}
                    <button
                      onClick={prevMainImage}
                      className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 w-8 h-8 sm:w-10 sm:h-10 bg-white/90 rounded-full flex items-center justify-center text-[#323c5f] hover:bg-white shadow-lg transition-all hover:scale-110"
                    >
                      <ChevronLeft size={20} className="sm:w-6 sm:h-6" />
                    </button>
                    <button
                      onClick={nextMainImage}
                      className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 w-8 h-8 sm:w-10 sm:h-10 bg-white/90 rounded-full flex items-center justify-center text-[#323c5f] hover:bg-white shadow-lg transition-all hover:scale-110"
                    >
                      <ChevronRight size={20} className="sm:w-6 sm:h-6" />
                    </button>
                  </div>

                  {/* Carrousel de vignettes */}
                  <div className="w-full">
                    <div className="flex justify-center gap-2 sm:gap-3 overflow-x-auto pb-2 px-2">
                      {ficheImages.map((image, index) => (
                        <button
                          key={index}
                          onClick={() => setCurrentMainImage(index)}
                          className={`flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 rounded-lg sm:rounded-xl overflow-hidden border-2 transition-all ${
                            currentMainImage === index
                              ? 'border-[#9a6ebd] ring-2 ring-[#9a6ebd]/50 scale-110'
                              : 'border-gray-200 hover:border-[#9a6ebd]/50 hover:scale-105'
                          }`}
                        >
                          <img
                            src={image.url}
                            alt={image.alt}
                            className="w-full h-full object-cover"
                          />
                        </button>
                      ))}
                    </div>
                    
                    {/* Indicateurs */}
                    <div className="flex justify-center gap-1 sm:gap-2 mt-3 sm:mt-4">
                      {ficheImages.map((_, index) => (
                        <button
                          key={index}
                          onClick={() => setCurrentMainImage(index)}
                          className={`w-2 h-2 sm:w-2 sm:h-2 rounded-full transition-all ${
                            currentMainImage === index
                              ? 'bg-[#9a6ebd] w-4 sm:w-6'
                              : 'bg-gray-300 hover:bg-[#9a6ebd]/50'
                          }`}
                        />
                      ))}
                    </div>
                    
                    <p className="text-center text-gray-600 mt-3 sm:mt-4 text-xs sm:text-sm px-4">
                      Cliquez sur l'image principale pour l'agrandir
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="border-b border-[#9a6ebd]/10" />

        {/* Section "Ce que contient la boîte" */}
        <section className="py-12 sm:py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-8 sm:mb-12">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#323c5f] mb-3 sm:mb-4">
                Un contenu complet pour une révision efficace
              </h2>
              <p className="text-lg sm:text-xl text-gray-600 px-4">
                35 fiches de révision + 35 vidéos explicatives couvrant tout le programme de Terminale
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
              {fichesByTheme.map((theme, index) => (
                <div
                  key={index}
                  className={`${theme.bgColor} rounded-xl p-4 sm:p-6 border-2 ${theme.borderColor} hover:shadow-lg transition-shadow`}
                >
                  <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
                    <div className={`w-8 h-8 sm:w-10 sm:h-10 rounded-lg ${theme.bgColor} border ${theme.borderColor} flex items-center justify-center`}>
                      <theme.icon className={theme.color} size={20} />
                    </div>
                    <h3 className={`text-sm sm:text-base font-semibold ${theme.color}`}>{theme.theme}</h3>
                  </div>
                  <div className="space-y-1 sm:space-y-2">
                    {theme.fiches.map((fiche, ficheIndex) => (
                      <div key={ficheIndex} className="flex items-center justify-between gap-2">
                        <span className="text-gray-700 text-xs sm:text-sm flex-1">{fiche.title}</span>
                        <span className={`px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full text-xs font-medium ${theme.bgColor} ${theme.color} border ${theme.borderColor} flex-shrink-0`}>
                          {fiche.count} fiche{fiche.count > 1 ? 's' : ''}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Total */}
            <div className="mt-8 sm:mt-12 text-center">
              <a
                href="https://editions-docere.fr/le-bac-de-ses-en-35-fiches/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#9a6ebd] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl hover:bg-[#8a5dad] transition-colors cursor-pointer"
              >
                <span className="text-xl sm:text-2xl font-bold">35 fiches + 35 vidéos</span>
                <p className="text-xs sm:text-sm opacity-90 mt-1">Programme complet de Terminale</p>
              </a>
            </div>
          </div>
        </section>
        <div className="border-b border-[#9a6ebd]/10" />

        {/* Section "Aperçu des fiches" */}
        <section className="py-12 sm:py-16 bg-[#9a6ebd]/5">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-8 sm:mb-12">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#323c5f] mb-3 sm:mb-4">
                Découvrez la qualité de nos fiches
              </h2>
              <p className="text-lg sm:text-xl text-gray-600 px-4">
                Cliquez sur les images pour voir les détails de nos fiches de révision
              </p>
            </div>

            {/* Carrousel d'exemples */}
            <div className="relative max-w-xl sm:max-w-2xl mx-auto">
              <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                <div className="relative h-80 sm:h-96 md:h-[500px]">
                  <img
                    src={exampleImages[currentCarouselIndex].url}
                    alt={exampleImages[currentCarouselIndex].alt}
                    className="w-full h-full object-contain cursor-pointer p-2 sm:p-0"
                    onClick={() => setSelectedImageIndex(currentCarouselIndex)}
                  />
                  
                  {/* Boutons de navigation */}
                  <button
                    onClick={prevImage}
                    className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 w-8 h-8 sm:w-10 sm:h-10 bg-white/80 rounded-full flex items-center justify-center text-[#323c5f] hover:bg-white z-10"
                  >
                    <ChevronLeft size={20} className="sm:w-6 sm:h-6" />
                  </button>
                  <button
                    onClick={nextImage}
                    className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 w-8 h-8 sm:w-10 sm:h-10 bg-white/80 rounded-full flex items-center justify-center text-[#323c5f] hover:bg-white z-10"
                  >
                    <ChevronRight size={20} className="sm:w-6 sm:h-6" />
                  </button>
                </div>
              </div>

              {/* Vignettes */}
              <div className="flex justify-center gap-1 sm:gap-2 mt-3 sm:mt-4 px-4">
                {exampleImages.map((image, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentCarouselIndex(index)}
                    className={`w-12 h-12 sm:w-16 sm:h-16 rounded-lg overflow-hidden border-2 transition-all flex-shrink-0 ${
                      currentCarouselIndex === index
                        ? 'border-[#9a6ebd] ring-2 ring-[#9a6ebd]/50'
                        : 'border-gray-200 hover:border-[#9a6ebd]/50'
                    }`}
                  >
                    <img
                      src={image.url}
                      alt={image.alt}
                      className="w-full h-full object-cover"
                    />
                  </button>
                ))}
              </div>

              <p className="text-center text-gray-600 mt-3 sm:mt-4 text-xs sm:text-sm px-4">
                Cliquez sur une image pour l'agrandir
              </p>
            </div>
          </div>
        </section>
        <div className="border-b border-[#9a6ebd]/10" />

        {/* Section "Les Auteurs" */}
        <section className="py-12 sm:py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col lg:grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
              <div>
                <h2 className="text-2xl sm:text-3xl font-bold text-[#323c5f] mb-4 sm:mb-6 text-center lg:text-left">
                  Les Auteurs : Marion Moreau et Brandon Maestu
                </h2>
                <div className="bg-[#9a6ebd]/5 rounded-xl p-4 sm:p-6 border-2 border-[#ceace8]">
                  <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">
                    Passionnés par les SES, ce duo de choc met toute son énergie à aider les lycéens 
                    et à transmettre leur goût pour la matière.
                  </p>
                  <p className="text-sm sm:text-base text-gray-600">
                    Parfaitement complémentaires, Marion incarne l'aspect sociologique du programme, 
                    tandis que Brandon, lui, se concentre sur l'aspect économique.
                  </p>
                </div>

                {/* Expertise */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-6 sm:mt-8">
                  <div className="bg-white p-3 sm:p-4 rounded-lg shadow-sm border border-[#ceace8]">
                    <Users className="text-[#9a6ebd] mb-2" size={24} />
                    <h4 className="text-sm sm:text-base font-semibold text-[#323c5f] mb-1">Marion</h4>
                    <p className="text-sm text-gray-600">Celle qui préfère la Sociologie</p>
                  </div>
                  <div className="bg-white p-3 sm:p-4 rounded-lg shadow-sm border border-[#ceace8]">
                    <Book className="text-[#9a6ebd] mb-2" size={24} />
                    <h4 className="text-sm sm:text-base font-semibold text-[#323c5f] mb-1">Brandon</h4>
                    <p className="text-sm text-gray-600">Celui qui préfère l'Économie</p>
                  </div>
                </div>
              </div>

              <div className="relative w-full max-w-md mx-auto lg:max-w-none">
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2FFiches%20r%C3%A9vision%2FCr%C3%A9ateurs.png?alt=media&token=8d10a517-1c5b-4266-b649-c0aeeaecde11"
                  alt="Marion Moreau et Brandon Maestu"
                  className="w-full rounded-xl sm:rounded-2xl shadow-xl"
                />
                <div className="absolute inset-0 rounded-2xl shadow-inner"></div>
              </div>
            </div>
          </div>
        </section>
        <div className="border-b border-[#9a6ebd]/10" />

        {/* Section FAQ */}
        <section className="py-12 sm:py-16 bg-[#9a6ebd]/5">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-8 sm:mb-12">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#323c5f] mb-4">
                Questions Fréquentes sur les Fiches SES
              </h2>
              <p className="text-lg sm:text-xl text-gray-600 px-4">
                Tout ce que vous devez savoir sur notre pack de fiches de révision
              </p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 lg:p-8 border-2 border-[#ceace8]">
              <FAQAccordion questions={faqData.fichesSES.questions} />
            </div>
          </div>
        </section>
        <div className="border-b border-[#9a6ebd]/10" />

        {/* Section Appel à l'Action Final */}
        <section className="py-12 sm:py-16 bg-gradient-to-r from-[#9a6ebd]/20 via-[#9a6ebd]/10 to-[#9a6ebd]/20">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="bg-white/80 backdrop-blur-sm p-6 sm:p-8 rounded-xl sm:rounded-2xl shadow-lg border border-[#9a6ebd]/20">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#323c5f] mb-4 sm:mb-6">
                Prêt à transformer vos révisions ?
              </h2>
              <p className="text-lg sm:text-xl text-gray-600 mb-6 sm:mb-8 px-2">
                Commandez dès maintenant et recevez vos fiches de révision chez vous !
              </p>
              <a
                href="https://editions-docere.fr/le-bac-de-ses-en-35-fiches/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-full sm:w-auto bg-[#9a6ebd] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl hover:bg-[#8a5dad] transition-colors text-base sm:text-lg font-semibold"
              >
                Commander sur Editions Docere
                <ExternalLink className="ml-2" size={20} />
              </a>
              <p className="text-xs sm:text-sm text-gray-500 mt-3 sm:mt-4 px-2">
                Vous serez redirigé vers notre éditeur Editions Docere pour finaliser votre achat
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      {/* Modal Pop-up pour les images */}
      {selectedImageIndex !== null && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-2 sm:p-4">
          <div className="relative max-w-full max-w-3xl max-h-[90vh] sm:max-h-[85vh] w-full flex items-center justify-center">
            <button
              onClick={() => setSelectedImageIndex(null)}
              className="absolute top-2 right-2 sm:top-4 sm:right-4 w-8 h-8 sm:w-10 sm:h-10 bg-white/90 rounded-full flex items-center justify-center text-gray-800 hover:bg-white z-10"
            >
              <X size={20} className="sm:w-6 sm:h-6" />
            </button>
            <img
              src={exampleImages[selectedImageIndex].url}
              alt={exampleImages[selectedImageIndex].alt}
              className="max-w-full max-h-full object-contain rounded-lg mx-2 sm:mx-0"
            />
            <div className="absolute bottom-2 sm:bottom-4 left-1/2 transform -translate-x-1/2 bg-white/90 px-3 sm:px-4 py-1 sm:py-2 rounded-full">
              <span className="text-xs sm:text-sm font-medium text-gray-800">
                {selectedImageIndex + 1} / {exampleImages.length}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FichesSESPage;